<template>
  <v-app>
    <Navbar />
    <v-main>
      <v-img src="@/assets/Background.png">
        <ErrorMessage />
        <StatusMessage />
        <router-view />
      </v-img>
    </v-main>
  </v-app>
</template>

<script>
import Navbar from "@/components/Navbar";
import ErrorMessage from "@/components/ErrorMessage.vue";
import StatusMessage from "@/components/StatusMessage.vue";

export default {
  name: "App",

  components: {
    Navbar,
    ErrorMessage,
    StatusMessage,
  },
};
</script>

<style lang="scss">
// .container {
//   max-width: 1280px;
// }

.theme--light.v-tabs-items {
  background-color: transparent !important;
}
</style>
